export default {
	title: 'Interesses',
	url: 'interesses',
	no_description: 'Nenhuma meta definida',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtros de vista'
		},
		general: {
			title: 'Geral'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Histórico'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_stake: 'Edição de interesse',
		create_stake: 'Criar novo interesse'
	},
	onboarding: {
		title: 'Revisão dos interesses',
		description:
			'A IA identificou os interesses estruturais do seu tema. Verifique se eles realmente representam o que você pode perder ou ganhar se nada for feito. Ajuste, remova ou complete conforme necessário.'
	}
};
